import { useRouter } from 'vue-router'

import { useSessionStore } from '../stores/session/session.store'
import { usePushStore } from '../stores/push'

/** Signs out and returns to the logout page. Shared by the drawer and the "Updated terms" screen. */
export function useSignOut() {
  const router = useRouter()
  const sessionStore = useSessionStore()
  const pushStore = usePushStore()

  async function signOut() {
    // Before the session ends, so the API still accepts the call. Capped at two seconds inside the store.
    await pushStore.forgetDevice()
    const logoutRoute = router.resolve({ name: 'logout' })
    return sessionStore.logout({
      logoutParams: {
        returnTo: new URL(logoutRoute.href, window.location.href).toString(),
        params: { utm_source: 'pwa-logout' }
      }
    })
  }

  return { signOut }
}
